import Shimmer from './Shimmer';

export const ShimmerTable = ({ arraySize }: { arraySize: number }) => {
  return (
    <div className="border-1 rounded-[10px] border-snow-white border-separate overflow-hidden">
      <table className="w-full text-left">
        <thead className="border-b-1 border-wo-grey ">
          <tr className="font-sans font-bold text-[12px]">
            <th className="p-2">
              <Shimmer width="100px" height="20px" />
            </th>
            <th className="p-2">
              <Shimmer width="50px" height="20px" />
            </th>
            <th className="p-2">
              <Shimmer width="70px" height="20px" />
            </th>
            <th className="p-2">
              <Shimmer width="60px" height="20px" />
            </th>
            <th className="p-2">
              <Shimmer width="50px" height="20px" />
            </th>
            <th className="p-2">
              <Shimmer width="50px" height="20px" />
            </th>
            <th className="p-2">
              <Shimmer width="50px" height="20px" />
            </th>
            <th className="p-2">
              <Shimmer width="50px" height="20px" />
            </th>
            <th className="p-2"></th>
          </tr>
        </thead>
        <tbody className="font-sans text-left font-normal text-[12px] text-navy-black">
          {[...Array(arraySize)].map((_, index) => (
            <tr key={index} className="border-b-1 border-light-grey ">
              <td className="p-2">
                <Shimmer width="100px" height="20px" />
              </td>
              <td className="p-2">
                <Shimmer width="50px" height="20px" />
              </td>
              <td className="p-2">
                <Shimmer width="70px" height="20px" />
              </td>
              <td className="p-2">
                <Shimmer width="60px" height="20px" />
              </td>
              <td className="p-2">
                <Shimmer width="50px" height="20px" />
              </td>
              <td className="p-2">
                <Shimmer width="50px" height="20px" />
              </td>
              <td className="p-2">
                <Shimmer width="50px" height="20px" />
              </td>
              <td className="p-2">
                <Shimmer width="50px" height="20px" />
              </td>
              <td className="p-2">
                <Shimmer width="80px" height="20px" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ShimmerTable;
